import axios from '../script/axiosAMS'

export default {
  getModemInfo (params, resultCallback) {
    axios.requestWith({
      url: '/api/modem',
      method: 'get',
      params: params,
      resultCallback: resultCallback
    })
  },
  modemInfo (method, data, resultCallback) {
    axios.requestWith({
      url: '/api/modem',
      method: method,
      data: data,
      resultCallback: resultCallback
    })
  },
  bulkInsertModemInfo (data, resultCallback, errorCallback) {
    axios.requestWith({
      url: '/api/modem',
      method: 'put',
      data: data,
      resultCallback: resultCallback,
      errorCallback: errorCallback
    })
  },
  bulkUpdateModemInfo (data, resultCallback, errorCallback) {
    axios.requestWith({
      url: '/api/modem',
      method: 'post',
      data: data,
      resultCallback: resultCallback,
      errorCallback: errorCallback
    })
  },
  getModemInfoHistory (params, resultCallback) {
    axios.requestWith({
      url: '/api/modem/history',
      method: 'get',
      params: params,
      resultCallback: resultCallback
    })
  },
  currentStates (data, resultCallback) {
    axios.requestWith({
      url: '/api/modem/currentStates',
      method: 'post',
      data: data,
      resultCallback: resultCallback
    })
  }
}



// WEBPACK FOOTER //
// ./src/script/modemInfo.js